var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsBoxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.04 17.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#888;stroke-miterlimit:10;stroke-width:1.37px;}.e{fill:#888;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M16.48,2.58c-.47-1.11-1.57-1.89-2.85-1.89H3.78C2.07,.69,.69,2.07,.69,3.78V13.63c0,1.35,.87,2.5,2.07,2.92"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 9,
    y: 8.77,
    width: 3.69,
    height: 3.69,
    rx: 0.64,
    ry: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 14.35,
    y: 3.51,
    width: 3.69,
    height: 3.69,
    rx: 0.64,
    ry: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 14.35,
    y: 8.77,
    width: 3.69,
    height: 3.69,
    rx: 0.64,
    ry: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 3.66,
    y: 14.03,
    width: 3.69,
    height: 3.69,
    rx: 0.64,
    ry: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 9,
    y: 14.03,
    width: 3.69,
    height: 3.69,
    rx: 0.64,
    ry: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 14.35,
    y: 14.03,
    width: 3.69,
    height: 3.69,
    rx: 0.64,
    ry: 0.64
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsBoxy);
export default __webpack_public_path__ + "static/media/appsBoxy.d5abb194a7f47cf919d9a5c12ed21a8f.svg";
export { ForwardRef as ReactComponent };